<template>
<div class="">
  <div class="text-white flex-1 col-span-1 border-0 overflow-hidden overflow-y-auto h-auto">
    <div class="pt-3 px-[16px] py-[16px] ">
        <block-loading v-if="loading"/>
      <div class="relative pb-3 col-partition-border" v-else>
          <div class="flex justify-between items-center pt-2">
              <h1 class="text-white font-semibold text-[24px]">Store Hours</h1>
              <button @click.prevent="save()" class="bg-white text-theme-green rounded  mt-2 px-4 py-2 hover:bg-theme-darkgreen hover:text-white"><span class="text-sm tracking-widest font-medium">SAVE</span></button>
          </div>
    
          <div v-bind:key="index + 'opening_hours'" v-for="(day, index) in form.operationHours"  class="">
            <div class="flex large:flex-row flex-col justify-between large:gap-3 py-1">
                <div class="w-full xl:w-1/3 flex items-center">
                    <div class="input-wrapper  w-[120px] flex items-center lg:mt-0 mt-5 large:h-[50px] large:mb-0 mb-3" >
                        <input type="checkbox" :id="day.dayName + index" v-model="day.isOpen" value="1" class="w-4 h-4 text-theme-green bg-transparent border-white focus:ring-theme-green">
                        <label :for="day.dayName + index" class="ml-2 cursor-pointer text-sm font-bold tracking-wider text-white">{{ day.dayName }}</label>
                    </div>
                </div>

              <div :class="'flex large:flex-row flex-col large:space-x-2 w-full lg:pb-6' + (day.isOpen ? '' : ' invisible')" >
                <div class="w-full xl:w-1/3">
                    <div :class="'input-wrapper large:mb-0 mb-3'" >
                        <label class="text-xs font-normal mb-1">Start Time</label>
                        <div class="block rounded bg-gray-black w-full relative">
                          
                          <div class="bg-gray-black  flex items-center w-full pr-[60px] rounded py-2">
                              <select  @change.prevent="validateStartEndTime(index)" v-model="day.openTime.HH"  class="bg-gray-black border-0 focus:border-transparent focus:ring-0 text-sm w-[100px] pl-2 py-0 pr-0 sm-arrow">
                                <option :value="hour > 9 ? hour : '0'+hour" v-bind:key="hour + 'hour'" v-for="hour in 12">{{ hour > 9 ? hour : '0'+hour }}</option>
                              </select>
                              <span>:</span>
                              <select  @change.prevent="validateStartEndTime(index)" v-model="day.openTime.MM"  class="bg-gray-black focus:border-transparent focus:ring-0 border-0 text-sm w-[100px] py-0 pl-2 pr-0 sm-arrow">
                                <option :value="min > 9 ? min : '0'+min" v-bind:key="min + 'min'" v-for="(key, min) in 60">{{ min > 9 ? min : '0'+min }}</option>
                              </select>
                            </div>

                            <label class="flex items-center cursor-pointer absolute right-2 top-2">
                                <input type="checkbox" @change.prevent="validateStartEndTime(index)" v-model="day.openTimeTypeAm"  class="hidden peer">
                                <div :class="'relative toggle-bg ampm-inside-switch border-2  h-6 w-[50px] rounded-full ' + (day.openTimeTypeAm ? 'bg-theme-darkgreen border-theme-green' : 'bg-theme-darkgreen  border-theme-green')">
                                  <span :class="'text-white  text-xs leading-loose ' + (day.openTimeTypeAm ? 'left' : 'right')">{{day.openTimeTypeAm ? 'AM' : 'PM'}}</span>
                                </div>
                            </label>
                        </div>
                    </div>
                </div>

                <div class="w-full xl:w-1/3">
                    <div :class="'input-wrapper large:mb-0 mb-3'" >
                        <label class="text-xs font-normal mb-1">End Time</label>
                        <div class="block rounded bg-gray-black w-full relative">
                          
                          <div class="bg-gray-black  flex items-center w-full pr-[60px] rounded py-2">
                              <select  @change.prevent="validateStartEndTime(index)" v-model="day.closeTime.HH" class="bg-gray-black border-0 focus:border-transparent focus:ring-0 text-sm w-[100px] pl-2 py-0 pr-0 sm-arrow">
                                <option :value="hour > 9 ? hour : '0'+hour" v-bind:key="hour + 'hour'" v-for="hour in 12">{{ hour > 9 ? hour : '0'+hour }}</option>
                              </select>
                              <span>:</span>
                              <select  @change.prevent="validateStartEndTime(index)" v-model="day.closeTime.MM" class="bg-gray-black focus:border-transparent focus:ring-0 border-0 text-sm w-[100px] py-0 pl-2 pr-0 sm-arrow">
                                <option :value="min > 9 ? min : '0'+min" v-bind:key="min + 'min'" v-for="(key, min) in 60">{{ min > 9 ? min : '0'+min }}</option>
                              </select>
                            </div>

                            <label class="flex items-center cursor-pointer absolute right-2 top-2">
                                <input type="checkbox" @change.prevent="validateStartEndTime(index)" v-model="day.closeTimeTypeAm" class="hidden peer">
                                <div :class="'relative toggle-bg ampm-inside-switch border-2  h-6 w-[50px] rounded-full ' + (day.closeTimeTypeAm ? 'bg-theme-darkgreen border-theme-green' : 'bg-theme-darkgreen  border-theme-green')">
                                  <span :class="'text-white  text-xs leading-loose ' + (day.closeTimeTypeAm ? 'left' : 'right')">{{day.closeTimeTypeAm ? 'AM' : 'PM'}}</span>
                                </div>
                            </label>
                        </div>
                    </div>
                </div>
              </div>
            </div>
            <p v-if="day.is_valid_openTime_closeTime == false" class="text-theme-red w-full text-end text-xs">End time must be greater than start time.</p>
          </div>
      </div>
    </div>
  </div>
</div>
</template>


<script lang="ts">
import  { defineComponent , ref} from "vue";
import { mapGetters, mapActions, mapMutations } from "vuex";
import { useSnackbar } from "vue3-snackbar";
import Helpers from '@/helpers';
import LocationInfoApis from '@/controllers/LocationInfoApis';
import LocationsApis from '@/controllers/LocationsApis';
import LocationOperationHoursApis from '@/controllers/LocationOperationHoursApis';
import moment from 'moment';

export default defineComponent({
  name: "LocationInfoStoreHours",
  components: {
  },

  setup() {
    const form = <any>ref({
      operationHours: []
    });
    
    const loading = ref(false);
    const snackbar = useSnackbar();
   
    return {
      loading,
      form,
      snackbar
    };
  },
 

  computed: {
    ...mapGetters({
      vg_selectedLocation: 'location/selected'
    }),
  },

  watch: {
    'vg_selectedLocation': async function() {
      this.loading = true;
      await this.fetchLocationOperationHours()
      this.loading = false;
    },

  },

  async mounted() {
    this.loading = true;
    await this.fetchLocationOperationHours()
    this.loading = false;
    this.emitter.on("location-info-submit", (infoData) => {
      this.validateStoreHoursAndSubmit(infoData);
    });
  },

  beforeDestroy() {
    this.emitter.off('location-info-submit', () => {})
  },

  methods: {
    /**
     * Assign api values to frontend readable values  
     */
    assignValues(payload) {
      this.form.operationHours = [];
      if(payload && payload.length > 0) {
        payload.forEach(record => {
           let open24HrTime = record.openTime;
           let open12HrTime = moment(open24HrTime, ["HH:mm:ss"]);
           let close24HrTime = record.closeTime;
           let close12HrTime = moment(close24HrTime, ["HH:mm:ss"]);
  
          this.form.operationHours.push({
            day: record.day,
            dayName: record.dayName,
            holidayDate: record.holidayDate,
            holidayDateDisplay: moment(record.holidayDate).format('MM/DD'),
            isOpen: record.isOpen,
            is_valid_openTime_closeTime: true,
            openTime: {
              HH: open12HrTime.format('hh'),
              MM: open12HrTime.format('mm'),
            },
            openTimeTypeAm: open12HrTime.format('A') == 'AM' ?  true : false,
            closeTime: {
              HH: close12HrTime.format('hh'),
              MM: close12HrTime.format('mm'),
            },
            closeTimeTypeAm: close12HrTime.format('A') == 'AM' ?  true : false,
          })
        })
      }
    },
    /**
     * Fetch location operation hours
     */ 
    async fetchLocationOperationHours() {
      this.form.operationHours = [];
      let defaultWeeklyHours = [
            {
                day: 0,
                dayName: "Sunday",
                isOpen: true,
                openTime: {
                  HH:'01',
                  MM:'00',
                },
                openTimeTypeAm: true,
                closeTime: {
                  HH:'01',
                  MM:'01',
                },
                closeTimeTypeAm: true,
                is_valid_openTime_closeTime: true,
            },
            {
                day: 1,
                dayName: "Monday",
                isOpen: true,
                openTime: {
                  HH:'01',
                  MM:'00',
                },
                openTimeTypeAm: true,
                closeTime: {
                  HH:'01',
                  MM:'01',
                },
                closeTimeTypeAm: true,
                is_valid_openTime_closeTime: true,
            },
            {
                day: 2,
                dayName: "Tuesday",
                isOpen: true,
                openTime: {
                  HH:'01',
                  MM:'00',
                },
                openTimeTypeAm: true,
                closeTime: {
                  HH:'01',
                  MM:'01',
                },
                closeTimeTypeAm: true,
                is_valid_openTime_closeTime: true,
            },
            {
              day: 3,
              dayName: "Wednesday",
              isOpen: true,
              openTime: {
                HH:'01',
                MM:'00',
              },
              openTimeTypeAm: true,
              closeTime: {
                HH:'01',
                MM:'01',
              },
              closeTimeTypeAm: true,
              is_valid_openTime_closeTime: true,
            },
            {
              day: 4,
              dayName: "Thursday",
              isOpen: true,
              openTime: {
                HH:'01',
                MM:'00',
              },
              openTimeTypeAm: true,
              closeTime: {
                HH:'01',
                MM:'01',
              },
              closeTimeTypeAm: true,
              is_valid_openTime_closeTime: true,
            },
            {
              day: 5,
              dayName: "Friday",
              isOpen: true,
              openTime: {
                HH:'01',
                MM:'00',
              },
              openTimeTypeAm: true,
              closeTime: {
                HH:'01',
                MM:'01',
              },
              closeTimeTypeAm: true,
              is_valid_openTime_closeTime: true,
            },
            {
              day: 6,
              dayName: "Saturday",
              isOpen: true,
              openTime: {
                HH:'01',
                MM:'00',
              },
              openTimeTypeAm: true,
              closeTime: {
                HH:'01',
                MM:'01',
              },
              closeTimeTypeAm: true,
              is_valid_openTime_closeTime: true,
            }
          ];
      let res = await LocationOperationHoursApis.fetchLocationOperationHours();
      if(res.status == 200) {
        if(res.data.payload && res.data.payload.length > 0) {
          this.assignValues(res.data.payload);
        } else {
          this.form.operationHours = defaultWeeklyHours;
        }
      } else {
        this.form.operationHours = defaultWeeklyHours;
      }
    },


     /**
      * validate store hours and submit
      */
    async validateStoreHoursAndSubmit(infoData) {
      // validated
      for (let i = 0; i < this.form.operationHours.length; i++) {
        if(this.form.operationHours[i].is_valid_openTime_closeTime == false) {
          return this.snackbar.add({
            type: 'info',
            text: 'End time must be greater than start time on ' + this.form.operationHours[i].dayName,
            duration: 3000,
          })
        }
      }
    
      // Make api readable format data
      let operationHours = <any>Helpers.convertLocation12hoursTo24hoursLocationInfo(this.form.operationHours);
      // now hit 2 apis 1 for location info update
      // next store hours 
      let storeInfo = LocationInfoApis.updateLocationInfo(infoData);
      let storeOperationHours = LocationOperationHoursApis.createLocationOperationHours({
        operationHours: operationHours
      });
      const self = this;
      this.va_spinner(true);
      Promise.all([storeInfo, storeOperationHours]).then(async function (res) {
        // this is always update
        self.va_spinner(false);

        if(res[0].status == 200 && res[1].status == 201) {
          self.snackbar.add({
            type: 'info',
            text: res[0].data.message,
            duration: 3000,
          })
          // some data changed then only sync else leva it
          if(self._lodash.isEqual(self.vg_selectedLocation, res[0].data.payload) == false) {
            const params = `includeBusinessBrandProfile=1`
            let resLoc:any = await LocationsApis.fetchAllLocations(params);
            self.vm_mutateLocations(resLoc?.data?.payload)
            let currentLoc = resLoc?.data?.payload?.find(loc => loc.id == res[0].data.payload.id);
            self.vm_mutateSelectedLocation(currentLoc)
          }
          
          // this is always create / update 201
          self.snackbar.add({
            type: 'info',
            text: res[1].data.message,
            duration: 3000,
          })
        }else{
          if(res[0].status !== 200){
            self.snackbar.add({
              type: 'info',
              text: Helpers.catchErrorMessage(res[0].response.data),
              duration: 3000,
            })
          }

          if(res[1].status !== 201){
            self.snackbar.add({
              type: 'info',
              text: Helpers.catchErrorMessage(res[1].response.data),
              duration: 3000,
            })
          }
        }
      })

    },

     /**
     * Validate start end time
     */
    async validateStartEndTime(index) {
       this.form.operationHours = await Helpers.validateStartEndTime(this.form.operationHours, index);
    },

    /**
     * Validation captures
     */
    async validateFields(fields) {
      let res = await Helpers.validateFormFields(this.form, fields);
      this.form = res.data;
      return res.error ? false : true;
    },

    save() {
      this.emitter.emit("validate-location-info", true);
      // 1no ma info save huna paryo uta validation success vayepaxi
      // 2 ma yeta validation agrnu paryo
      // 3 2 tai success vayepaxi 2 ta api hit garna paryo
    },
    ...mapMutations({
      vm_mutateLocations: "location/mutateLocations",
      vm_mutateSelectedLocation: "location/mutateSelectedLocation"
    }),

    ...mapActions({
      va_spinner: "spinner/setSpinner",
    })
  }
});
</script>



